// Error.jsx
// TK 10/17/2022

// Packages, Dependencies, and Shared Libraries
import React from "react";
import { useNavigate } from "react-router-dom";

// Images
import plantAtComputer from "../Images/Graphics/plantAtComputer.png";

// CSS
import "./MiscPages.css";

/*******************************************************************************
 * @func Error (React Component)
 * The component that should be displayed whenever there is an error. It will
 * show a description of the error and display a graphic.
 *
 * @param error (string): The error from firebase that explains why the plant
 * cannot be loaded
 * @return JSX Element
 *
 * @notes None
 *
 ******************************************************************************/
const Error = ({ error }) => {
  // Constants
  const navigate = useNavigate();

  return (
    <div className="font-global text-center px-4 py-8 max-w-[500px] mx-auto">
      <div className="font-header text-3xl text-leaf-green-dark mb-2">
        Uh oh...
      </div>
      <div className="text-leaf-brown-soft text-sm mb-4">{error}</div>
      <img
        className="w-full max-w-[360px] mx-auto block"
        src={plantAtComputer}
        alt="Plant at computer"
      />
      <div className="mt-6 flex flex-col sm:flex-row gap-3 justify-center">
        <button className="button" onClick={() => navigate("/")}>
          Go home
        </button>
        <button className="button" onClick={() => navigate("/random")}>
          Check out a random plant
        </button>
      </div>
    </div>
  );
}; // End Error

export default Error;
